import { apiCallWithSignal } from "../../axios";
import queryString from "query-string";

import { IAlertAssigned } from "@/data/interfaces/alert";
import { ICamera } from "@/data/interfaces/camera";
import { IThing } from "@/data/interfaces/thing";

export interface IFetchAlertResponse {
  alert: IAlertAssigned | null;
  cameras: ICamera[];
  count: number;
  errors: string | null;
  isLocationEscalated: boolean;
  locationQueuePaused: boolean;
  queueIsPaused: boolean;
  requestedBy: number;
  status: number;
  success: boolean;
  things: IThing[];
}
const fetchAlert = async (opts: any = null, signal: any): Promise<IFetchAlertResponse> => {
  const stringified = queryString.stringify(opts);
  let tail = `operator/assign`;
  if (opts) tail += `?${stringified}`;
  const res = await apiCallWithSignal<{ data: IFetchAlertResponse }>("GET", tail, null, signal);
  return res.data;
};

export default fetchAlert;
